<template>
  <BaseScreen v-bind="screen">
    <BaseAlert
      v-if="isErrorVisible"
      v-bind="error"
      slot="middle"
    />
    <Tickets
      v-bind="tickets"
      class="screen__stretch screen__offset-right"
      @pick="pickTicket"
    />
  </BaseScreen>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import screenMixin from '@/mixins/screen';

import Tickets from '@/components/Tickets.vue';

export default {
  name: 'TicketEntryScreen',
  mixins: [screenMixin],
  components: {
    Tickets,
  },
  computed: {
    ...mapState('tickets', [
      'entry',
    ]),
    titleText() {
      return this.$t('tickets.entryTicket');
    },
    screenCase() {
      if (this.isErrorVisible) {
        return 'STEP_BUY_NOT_POSSIBLE';
      }
      if (this.hasTickets) {
        return 'STEP_TICKET_ENTRY';
      }
      return null;
    },
    tickets() {
      return {
        items: this.entry,
        note: {
          text: this.$t('tickets.note'),
          size: 'l',
          isCenter: true,
          theme: 'note',
        },
      };
    },
    error() {
      return {
        icon: {
          name: 'important',
          theme: 'error',
          view: 'circle',
          size: 'l',
        },
        title: {
          text: this.$t('tickets.notPossible'),
          size: 'l',
        },
        description: {
          text: this.$t('tickets.badTime'),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('tickets.goHome'),
            action: this.goToHomeScreen,
          },
        ],
      };
    },
    hasTickets() {
      return Boolean(this.entry?.length);
    },
  },
  created() {
    this.checkTickets();
    this.initActions([
      ['ACTION_STANDART_TICKET', this.pickFirstTicket],
    ]);
  },
  methods: {
    ...mapMutations('tickets', [
      'setTicket',
      'setCount',
    ]),
    pickTicket(ticket) {
      if (!ticket) return;
      this.setTicket(ticket);
      this.setCount(1);
      this.goToTicketsCountScreen();
    },
    checkTickets() {
      return this.hasTickets ? true : this.showError();
    },
    pickFirstTicket() {
      const [firstTicket] = this.entry;
      this.pickTicket(firstTicket);
    },
    goToTicketsCountScreen() {
      this.$router.push(this.$router.options.paths.ticketsCount);
    },
  },
};
</script>
